import useMutation from '@tcs/common/hooks/useMutation';
import { useQuery } from '@tcs/common/hooks/useQuery';
import {
  PasswordChange,
  Question,
  QuestionAnswer,
} from '@tcs/client-portal-api/src/types/Auth';
import {
  ResetPasswordCommandModel,
  TokenResetPasswordCommandModel,
} from '@tcs/client-portal-api/platform_generated';

export const useChangePassword = () =>
  useMutation<PasswordChange>('/Authorization/PasswordChange');

export const useGetQuestion = () => {
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery<Question, Error>('/Authorization/Question/GetQuestion');
  return {
    error,
    loading,
    data,
  };
};

export const usePasswordResetMutation = (options?: unknown) =>
  useMutation<ResetPasswordCommandModel>(
    '/Authorization/PasswordReset',
    options
  );
export const useTokenSetPasswordMutation = (options?: unknown) =>
  useMutation<TokenResetPasswordCommandModel>(
    '/Authorization/TokenSetPassword',
    options
  );

export const usePasswordResetQuestion = (identity?: {
  identityId: string;
  email: string;
}) => {
  const {
    data,
    error,
    isLoading: loading,
  } = useQuery<Question, Error>(
    `/Authorization/PasswordReset/Question?identityId=${
      identity?.identityId
    }&email=${encodeURIComponent(identity?.email)}`,
    {
      enabled: identity !== undefined,
      retry: false,
    }
  );

  return {
    data,
    error,
    loading,
  };
};

export const useUpdateQuestion = () =>
  useMutation<QuestionAnswer>('/Authorization/Question/UpdateQuestion');
